import isPhoneNumberValid from './isPhoneNumberValid';

// Проверить, является ли номер Qiwi-кошелька валидным
// Номер кошелька - это номер мобильного телефона
//
// number: string
export default function isQiwiWalletNumberValid(number) {
  return isPhoneNumberValid(number);
}
